// @flow

import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontNormal } from "@fdr/static-ui/Typography";

export const RunnerNumberGroupMolecule = styled.ol`
  list-style-type: none;
  display: flex;
  width: 100%;
  align-items: center;
  ${({ hasHorseName }) =>
    hasHorseName &&
    css`
      align-items: flex-start;
      flex-direction: column;
    `};
`;

export const ListItem = styled.li`
  ${({ hasHorseName }) => !hasHorseName && "width: 16px;"};
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ hasLabel }) =>
    hasLabel
      ? css`
          &:nth-child(n + 3) {
            ${({ hasHorseName }) =>
              hasHorseName ? " margin-top: 8px;" : " margin-left: 2px;"};
          }
        `
      : css`
          &:nth-child(n + 2) {
            ${({ hasHorseName }) =>
              hasHorseName ? " margin-top: 8px;" : " margin-left: 2px;"};
          }
        `}
`;

export const LabelItem = styled.li`
  height: 16px;
  display: inline-flex;
  align-items: center;
  ${({ isVertical }) =>
    !isVertical
      ? css`
          margin-right: 4px;
        `
      : css`
          width: 24px;
          margin-right: 8px;
        `}
`;

export const HorseName = styled.span`
  padding-left: 8px;
  font-size: 12px;
  font-family: ${fontNormal};
  line-height: 125%;
  color: ${buildColor("grey", "D4")};
`;
